import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store/rootReducer";
import { HelpReducer } from "src/pages/DashboardPage/vpo/types/state";

export const gosHelpSelector = createSelector(
  (state: RootState) => state.gosStrapi.help,
  (state: HelpReducer) => state.data,
);

export const gosHelpStatusSelector = createSelector(
  (state: RootState) => state.gosStrapi.help,
  (state: HelpReducer) => state.fetchingStatusSettings,
);
